import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pickupNow: {
    id: 'pd.clickandcollect.pickup.now',
    defaultMessage: 'Vyzvednout ihned',
  },
});
